import AreaFeatureCardGridView from "@/components/areas/AreaFeatureCardGridView";
import { useAreaName } from "@/hooks/useAreaName";
import type { LayoutContext } from "@/lib/models";
import { useEffect } from "react";
import { useOutletContext, useParams } from "react-router";

const AreaHabitatFeatureListPage: React.FC = () => {
  const params = useParams();
  const { areaName } = useAreaName(params.areaId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Area: ${areaName} Habitat Features`);
    }, [areaName, setPageName]);

  return (
     <AreaFeatureCardGridView featureTypeSubType="Habitat" />
  );
};

export default AreaHabitatFeatureListPage;
